import { M365PulseSiteLayout, useInLayout } from "Core/M365PulseSiteLayout";

import { IUnauthenticatedPageProps } from "./UnauthenticatedPage.types";
import React from "react";
import { observer } from "mobx-react";
import { useSmallScreen } from "Shared/Hooks";
import { useStyles } from "./UnauthenticatedPage.styles";

const UnauthenticatedPageBase = (props: IUnauthenticatedPageProps) => {
    const { content } = props;
    const isSmallScreen = useSmallScreen();
    const classNames = useStyles(isSmallScreen);
    const inLayout = useInLayout();

    return inLayout || props.login ? (
        <div className={classNames.contentBlock}>{content}</div>
    ) : (
        <M365PulseSiteLayout>
            <div className={classNames.contentBlock}>{content}</div>
        </M365PulseSiteLayout>
    );
};

export const UnauthenticatedPage = observer(UnauthenticatedPageBase);
